import { shape, number, string, bool, arrayOf } from 'prop-types'
import administratorType from './administratorType'

export default shape({
  rid:    number,
  name:   string,
  admins: arrayOf(administratorType)
})
